import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { ReviewerInteraction } from '@sleipai/sleip-models';
import { adapter, reviewerInteractionFeatureKey, State } from '../reducers/reviewer-interaction.reducer';

export const selectReviewerInteractionState = createFeatureSelector<State>(reviewerInteractionFeatureKey);

export const isLoading = (state: State): boolean => state.loading;
export const isLoaded = (state: State): boolean => state.loaded;

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectReviewerInteractionState,
  isLoading
);
export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectReviewerInteractionState,
  isLoaded
);

export const selectAllInteractions: (state: object) => ReviewerInteraction[] = adapter.getSelectors(
  selectReviewerInteractionState
).selectAll;

export const selectSingleInteraction = (id: string) =>
  createSelector(selectAllInteractions, (interactions: ReviewerInteraction[]) => {
    if (interactions.length) {
      return interactions.find(i => i.recordingId == id);
    } else {
      return false;
    }
  });
